/**
 * OEM 品牌管理（管理员 / 运营）
 */
<template>
  <div class="oem-brand-manage-page">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>OEM 贴牌</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="search-section">
      <el-form :inline="true" :model="searchForm" size="small" class="search-form">
        <el-form-item label="域名">
          <el-input
            v-model="searchForm.domain"
            placeholder="客户域名"
            clearable
            class="search-input"
            @keyup.enter.native="onSearch"
          />
        </el-form-item>
        <el-form-item label="站点类型">
          <el-select v-model="searchForm.siteType" placeholder="全部" clearable class="search-input">
            <el-option label="WEB" :value="1" />
            <el-option label="H5" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="启用状态">
          <el-select v-model="searchForm.enabled" placeholder="全部" clearable class="search-input">
            <el-option label="启用" :value="1" />
            <el-option label="停用" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSearch">搜索</el-button>
          <el-button icon="el-icon-refresh-left" @click="onReset">清空</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="toolbar">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="openBrandDialog()">
        新增
      </el-button>
      <el-button size="small" :loading="reloadLoading" @click="handleReloadNginx">
        仅重载 Nginx
      </el-button>
    </div>

    <el-card shadow="hover" class="table-card">
      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="加载中"
        empty-text="暂无数据"
        style="width: 100%"
        border
      >
        <el-table-column prop="domain" label="域名" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button type="text" @click="copyText(scope.row.domain)">{{ scope.row.domain }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="站点类型" width="90" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="siteTypeTagType(scope.row.siteType)">
              {{ siteTypeText(scope.row.siteType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="关联H5域名" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <template v-if="normalizeSiteType(scope.row.siteType) === 1">
              <el-button
                v-if="getRowH5Domain(scope.row)"
                type="text"
                @click="copyText(getRowH5Domain(scope.row))"
              >{{ getRowH5Domain(scope.row) }}</el-button>
              <span v-else class="muted">默认</span>
            </template>
            <span v-else class="muted">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="systemName" label="系统名称" min-width="140" show-overflow-tooltip />
        <el-table-column label="Logo" width="90" align="center">
          <template slot-scope="scope">
            <a
              v-if="getRowLogoUrl(scope.row)"
              :href="getRowLogoUrl(scope.row)"
              target="_blank"
              rel="noopener noreferrer"
              class="media-thumb-link"
              :title="getRowLogoUrl(scope.row)"
            >
              <img
                class="media-thumb media-thumb--logo"
                :src="getRowLogoUrl(scope.row)"
                alt="logo"
                referrerpolicy="no-referrer"
                @error="onMediaError($event)"
              />
            </a>
            <span v-else class="muted">无</span>
          </template>
        </el-table-column>
        <el-table-column label="Favicon" width="90" align="center">
          <template slot-scope="scope">
            <a
              v-if="getRowFaviconUrl(scope.row)"
              :href="getRowFaviconUrl(scope.row)"
              target="_blank"
              rel="noopener noreferrer"
              class="media-thumb-link"
              :title="getRowFaviconUrl(scope.row)"
            >
              <img
                class="media-thumb media-thumb--favicon"
                :src="getRowFaviconUrl(scope.row)"
                alt="favicon"
                referrerpolicy="no-referrer"
                @error="onMediaError($event)"
              />
            </a>
            <span v-else class="muted">无</span>
          </template>
        </el-table-column>
        <el-table-column label="启用" width="90" align="center">
          <template slot-scope="scope">
            <el-switch
              :value="Number(scope.row.enabled) === 1"
              :disabled="switchLoadingId === scope.row.id"
              @change="(val) => onToggleEnabled(scope.row, val)"
            />
          </template>
        </el-table-column>
        <el-table-column label="证书状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="certStatusType(scope.row.certStatus)">
              {{ certStatusText(scope.row.certStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="证书到期" width="120" align="center">
          <template slot-scope="scope">
            <span :class="{ 'expire-warn': isExpireSoon(scope.row.certExpireAt) }">
              {{ formatDate(scope.row.certExpireAt) || '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="lastPublishMsg" label="最近发布说明" min-width="160" show-overflow-tooltip />
        <el-table-column label="操作" width="280" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" plain @click="openBrandDialog(scope.row)">编辑</el-button>
            <el-button type="primary" size="mini" plain @click="openCertDialog(scope.row)">上传证书</el-button>
            <el-button
              type="primary"
              size="mini"
              plain
              :disabled="Number(scope.row.certStatus) !== 1"
              :loading="publishLoadingId === scope.row.id"
              @click="handlePublish(scope.row)"
            >
              发布
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrap">
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather" />
      </div>
    </el-card>

    <!-- 新建 / 编辑品牌 -->
    <el-dialog
      :title="brandForm.id ? '编辑 OEM 品牌' : '新增 OEM 品牌'"
      :visible.sync="brandDialogVisible"
      width="620px"
      @close="resetBrandForm"
    >
      <el-form ref="brandFormRef" :model="brandForm" :rules="brandRules" label-width="100px" size="small">
        <el-form-item label="域名" prop="domain">
          <el-input
            v-model="brandForm.domain"
            placeholder="如 settle.kehu-a.com"
            :disabled="!!brandForm.id"
            maxlength="128"
          />
        </el-form-item>
        <el-form-item label="站点类型" prop="siteType">
          <el-radio-group
            v-model="brandForm.siteType"
            :disabled="!!brandForm.id"
            @change="onSiteTypeChange"
          >
            <el-radio :label="1">WEB</el-radio>
            <el-radio :label="2">H5</el-radio>
          </el-radio-group>
          <div v-if="brandForm.id" class="form-tip">站点类型新建后不可修改</div>
        </el-form-item>
        <el-form-item
          v-if="normalizeSiteType(brandForm.siteType) === 1"
          label="关联H5域名"
          prop="linkedH5Domain"
        >
          <el-input
            v-model="brandForm.linkedH5Domain"
            placeholder="选填，如 h5.kehu-a.com；不填则扫码走平台默认 H5"
            maxlength="128"
            clearable
          />
          <div class="form-tip">WEB 扫码进入小程序时使用；不传则后端使用默认 H5 配置</div>
        </el-form-item>
        <el-form-item label="系统名称" prop="systemName">
          <el-input v-model="brandForm.systemName" placeholder="选填，不填则登录页/侧栏不显示系统名" maxlength="64" show-word-limit />
        </el-form-item>
        <el-form-item label="Logo" prop="logoFile">
          <div class="upload-row">
            <el-upload
              action=""
              :show-file-list="false"
              :http-request="onPickLogo"
              accept="image/png,image/jpeg,image/gif,image/webp,image/svg+xml"
            >
              <el-button size="mini" type="primary" plain>
                {{ brandForm.id ? '更换 Logo' : '选择 Logo' }}
              </el-button>
            </el-upload>
            <el-image
              v-if="logoPreviewUrl"
              :src="logoPreviewUrl"
              style="width: 80px; height: 36px; margin-left: 12px"
              fit="contain"
            />
            <el-button
              v-if="pendingLogoFile"
              type="text"
              size="mini"
              style="margin-left: 8px"
              @click="clearPendingLogo"
            >
              清除
            </el-button>
          </div>
          <div class="form-tip">{{ brandForm.id ? '编辑时可选换 Logo，随表单一起提交' : '新建必选 Logo 文件，随表单一并提交' }}</div>
        </el-form-item>
        <el-form-item label="Favicon">
          <div class="upload-row">
            <el-upload
              action=""
              :show-file-list="false"
              :http-request="onPickFavicon"
              accept="image/x-icon,image/png,image/jpeg,.ico"
            >
              <el-button size="mini" type="primary" plain>
                {{ brandForm.id ? '更换 Favicon' : '选择 Favicon' }}
              </el-button>
            </el-upload>
            <el-image
              v-if="faviconPreviewUrl"
              :src="faviconPreviewUrl"
              style="width: 28px; height: 28px; margin-left: 12px"
              fit="contain"
            />
            <el-button
              v-if="pendingFaviconFile"
              type="text"
              size="mini"
              style="margin-left: 8px"
              @click="clearPendingFavicon"
            >
              清除
            </el-button>
          </div>
          <div class="form-tip">{{ brandForm.id ? '编辑时可选换 Favicon，随表单一起提交' : '可选，随新建表单一并提交' }}</div>
        </el-form-item>
        <el-form-item label="版权">
          <el-input v-model="brandForm.copyright" placeholder="登录页版权文案" maxlength="256" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="brandForm.remark" type="textarea" :rows="2" maxlength="256" />
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="brandForm.enabled" :active-value="1" :inactive-value="0" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="brandDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="brandSubmitLoading" @click="submitBrandForm">
          确定
        </el-button>
      </span>
    </el-dialog>

    <!-- 上传证书 -->
    <el-dialog
      title="上传 SSL 证书"
      :visible.sync="certDialogVisible"
      width="560px"
      @close="resetCertForm"
    >
      <el-alert
        type="info"
        :closable="false"
        show-icon
        title="证书由客户提供与续期；上传成功后请再点「发布」才会生成 Nginx 配置并重载。"
        style="margin-bottom: 16px"
      />
      <el-form label-width="100px" size="small">
        <el-form-item label="域名">
          <span>{{ currentRow.domain }}</span>
        </el-form-item>
        <el-form-item label="完整链 pem" required>
          <el-upload
            ref="pemUpload"
            action=""
            :auto-upload="false"
            :limit="1"
            :on-change="onPemChange"
            :on-remove="onPemRemove"
            accept=".pem,.crt,.cer"
          >
            <el-button size="mini" type="primary" plain>选择 pem / crt</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="私钥 key" required>
          <el-upload
            ref="keyUpload"
            action=""
            :auto-upload="false"
            :limit="1"
            :on-change="onKeyChange"
            :on-remove="onKeyRemove"
            accept=".key,.pem"
          >
            <el-button size="mini" type="primary" plain>选择 key</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item v-if="currentRow.certExpireAt" label="当前到期">
          <span :class="{ 'expire-warn': isExpireSoon(currentRow.certExpireAt) }">
            {{ formatDate(currentRow.certExpireAt) }}
          </span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="certDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="certSubmitLoading" @click="submitCert">
          上传
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  listOemBrand,
  createOemBrand,
  updateOemBrand,
  uploadOemCert,
  publishOem,
  disableOem,
  enableOem,
  reloadOemNginx
} from '../../api/userMG';
import Pagination from '../../components/Pagination';

const DOMAIN_REG = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+$/;

export default {
  name: 'OemBrandManage',
  components: { Pagination },
  data() {
    const validateDomain = (rule, value, callback) => {
      const v = (value || '').trim().toLowerCase();
      if (!v) {
        callback(new Error('请输入域名'));
        return;
      }
      if (v.indexOf('..') > -1 || v.indexOf('/') > -1 || /\s/.test(v)) {
        callback(new Error('域名格式不合法'));
        return;
      }
      if (!DOMAIN_REG.test(v)) {
        callback(new Error('域名格式不合法'));
        return;
      }
      callback();
    };
    const validateLogoFile = (rule, value, callback) => {
      // 编辑不强制重新上传；新建必须已选文件
      if (this.brandForm && this.brandForm.id) {
        callback();
        return;
      }
      if (this.pendingLogoFile || value) {
        callback();
        return;
      }
      callback(new Error('请选择 Logo 文件'));
    };
    // 关联 H5 域名：选填；有值时校验域名格式
    const validateH5Domain = (rule, value, callback) => {
      const v = (value || '').trim().toLowerCase();
      if (!v) {
        callback();
        return;
      }
      if (v.indexOf('..') > -1 || v.indexOf('/') > -1 || /\s/.test(v)) {
        callback(new Error('H5 域名格式不合法'));
        return;
      }
      if (!DOMAIN_REG.test(v)) {
        callback(new Error('H5 域名格式不合法'));
        return;
      }
      callback();
    };
    return {
      loading: false,
      reloadLoading: false,
      brandSubmitLoading: false,
      certSubmitLoading: false,
      switchLoadingId: null,
      publishLoadingId: null,
      brandDialogVisible: false,
      certDialogVisible: false,
      listData: [],
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      searchForm: {
        domain: '',
        siteType: null,
        enabled: null
      },
      brandForm: {
        id: null,
        domain: '',
        siteType: 1,
        linkedH5Domain: '',
        systemName: '',
        logoUrl: '',
        faviconUrl: '',
        logoFile: '',
        copyright: '',
        remark: '',
        enabled: 1
      },
      brandRules: {
        domain: [{ required: true, validator: validateDomain, trigger: 'blur' }],
        siteType: [{ required: true, message: '请选择站点类型', trigger: 'change' }],
        linkedH5Domain: [{ validator: validateH5Domain, trigger: 'blur' }],
        logoFile: [{ validator: validateLogoFile, trigger: 'change' }]
      },
      currentRow: {},
      pemFile: null,
      keyFile: null,
      pendingLogoFile: null,
      pendingFaviconFile: null,
      pendingLogoPreview: '',
      pendingFaviconPreview: ''
    };
  },
  computed: {
    logoPreviewUrl() {
      return this.pendingLogoPreview || this.brandForm.logoUrl || '';
    },
    faviconPreviewUrl() {
      return this.pendingFaviconPreview || this.brandForm.faviconUrl || '';
    }
  },
  created() {
    if (!this.checkPermission()) return;
    this.fetchList();
  },
  methods: {
    checkPermission() {
      const user = JSON.parse(localStorage.getItem('user_info') || '{}');
      const roleId = Number(user.roleId);
      // 1 管理员，5 运营
      if (roleId !== 1 && roleId !== 5) {
        this.$message.error('无权限访问 OEM 管理');
        this.$router.replace('/login');
        return false;
      }
      return true;
    },
    isApiOk(res) {
      return res && (res.msg === 'success' || res.code === 0 || res.code === '0');
    },
    /**
     * MinIO 预签名地址多为 http，管理端若是 https 会被浏览器混合内容拦截。
     * 同 host 时尽量升为 https；并去掉可能导致签名异常的多余空白。
     */
    resolveMediaUrl(url) {
      if (!url) return '';
      let src = String(url).trim();
      if (!src) return '';
      if (typeof window !== 'undefined' && window.location.protocol === 'https:' && /^http:\/\//i.test(src)) {
        try {
          const u = new URL(src);
          const pageHost = window.location.hostname;
          if (u.hostname === pageHost || u.hostname.endsWith('.' + pageHost)) {
            src = 'https://' + src.slice('http://'.length);
          }
        } catch (e) {
          /* ignore */
        }
      }
      return src;
    },
    getRowLogoUrl(row) {
      return this.resolveMediaUrl(row.logoUrl || row.logo_url || '');
    },
    getRowFaviconUrl(row) {
      return this.resolveMediaUrl(row.faviconUrl || row.favicon_url || '');
    },
    getRowH5Domain(row) {
      if (!row) return '';
      return String(
        row.linkedH5Domain || row.linked_h5_domain || row.h5Domain || row.h5_domain || ''
      ).trim();
    },
    onSiteTypeChange(val) {
      if (this.normalizeSiteType(val) !== 1) {
        this.brandForm.linkedH5Domain = '';
        this.$nextTick(() => {
          this.$refs.brandFormRef && this.$refs.brandFormRef.clearValidate('linkedH5Domain');
        });
      }
    },
    onMediaError(e) {
      const img = e && e.target;
      if (!img) return;
      img.style.display = 'none';
      const parent = img.parentNode;
      if (!parent || parent.querySelector('.media-error')) return;
      const tip = document.createElement('span');
      tip.className = 'muted media-error';
      tip.textContent = '加载失败';
      tip.title = img.getAttribute('src') || '';
      parent.appendChild(tip);
    },
    fetchList() {
      this.loading = true;
      const params = {
        page: this.pageparm.page,
        pageSize: this.pageparm.pageSize
      };
      if (this.searchForm.domain) params.domain = this.searchForm.domain.trim();
      if (this.searchForm.siteType === 1 || this.searchForm.siteType === 2) {
        params.siteType = this.searchForm.siteType;
      }
      if (this.searchForm.enabled === 0 || this.searchForm.enabled === 1) {
        params.enabled = this.searchForm.enabled;
      }
      listOemBrand(params)
        .then((res) => {
          if (this.isApiOk(res) && res.data) {
            const data = res.data;
            this.listData = data.items || data.list || data.records || [];
            this.pageparm.total =
              data.totalCount != null ? data.totalCount : data.total != null ? data.total : 0;
          } else {
            this.listData = [];
            if (res && res.msg && res.msg !== 'success') {
              this.$message.error(res.msg);
            }
          }
        })
        .catch(() => {
          this.listData = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    callFather(parm) {
      this.pageparm.page = parm.page;
      this.pageparm.pageSize = parm.pageSize;
      this.fetchList();
    },
    onSearch() {
      this.pageparm.page = 1;
      this.fetchList();
    },
    onReset() {
      this.searchForm.domain = '';
      this.searchForm.siteType = null;
      this.searchForm.enabled = null;
      this.onSearch();
    },
    /** 1 WEB / 2 H5；缺省按 WEB 展示（兼容旧数据） */
    normalizeSiteType(val) {
      return Number(val) === 2 ? 2 : 1;
    },
    siteTypeText(val) {
      return this.normalizeSiteType(val) === 2 ? 'H5' : 'WEB';
    },
    siteTypeTagType(val) {
      return this.normalizeSiteType(val) === 2 ? 'warning' : '';
    },
    certStatusText(status) {
      const map = { 0: '未上传', 1: '已上传', 2: '无效' };
      return map[Number(status)] != null ? map[Number(status)] : '未上传';
    },
    certStatusType(status) {
      const map = { 0: 'info', 1: 'success', 2: 'danger' };
      return map[Number(status)] || 'info';
    },
    formatDate(val) {
      if (!val) return '';
      const s = String(val);
      return s.length >= 10 ? s.slice(0, 10) : s;
    },
    isExpireSoon(val) {
      if (!val) return false;
      const t = new Date(val).getTime();
      if (Number.isNaN(t)) return false;
      const diff = t - Date.now();
      return diff >= 0 && diff <= 30 * 24 * 60 * 60 * 1000;
    },
    copyText(text) {
      if (!text) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success('已复制域名');
        });
        return;
      }
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$message.success('已复制域名');
    },
    openBrandDialog(row) {
      this.clearPendingLogo();
      this.clearPendingFavicon();
      if (row && row.id) {
        this.brandForm = {
          id: row.id,
          domain: row.domain || '',
          siteType: this.normalizeSiteType(row.siteType != null ? row.siteType : row.site_type),
          linkedH5Domain: this.getRowH5Domain(row),
          systemName: row.systemName || '',
          logoUrl: row.logoUrl || row.logo_url || '',
          faviconUrl: row.faviconUrl || row.favicon_url || '',
          logoFile: row.logoUrl || row.logo_url || '1',
          copyright: row.copyright || '',
          remark: row.remark || '',
          enabled: Number(row.enabled) === 0 ? 0 : 1
        };
      } else {
        this.resetBrandForm();
      }
      this.brandDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.brandFormRef && this.$refs.brandFormRef.clearValidate();
      });
    },
    resetBrandForm() {
      this.clearPendingLogo();
      this.clearPendingFavicon();
      this.brandForm = {
        id: null,
        domain: '',
        siteType: 1,
        linkedH5Domain: '',
        systemName: '',
        logoUrl: '',
        faviconUrl: '',
        logoFile: '',
        copyright: '',
        remark: '',
        enabled: 1
      };
      this.$refs.brandFormRef && this.$refs.brandFormRef.resetFields();
    },
    clearPendingLogo() {
      if (this.pendingLogoPreview) {
        URL.revokeObjectURL(this.pendingLogoPreview);
      }
      this.pendingLogoFile = null;
      this.pendingLogoPreview = '';
      if (this.brandForm && !this.brandForm.id) {
        this.brandForm.logoFile = '';
      }
    },
    clearPendingFavicon() {
      if (this.pendingFaviconPreview) {
        URL.revokeObjectURL(this.pendingFaviconPreview);
      }
      this.pendingFaviconFile = null;
      this.pendingFaviconPreview = '';
    },
    buildBrandFormData(isCreate) {
      const formData = new FormData();
      formData.append('domain', (this.brandForm.domain || '').trim().toLowerCase());
      formData.append('siteType', String(this.normalizeSiteType(this.brandForm.siteType)));
      // WEB 可选关联 H5；新建不传=默认；编辑传空=回退默认
      if (this.normalizeSiteType(this.brandForm.siteType) === 1) {
        const linkedH5Domain = (this.brandForm.linkedH5Domain || '').trim().toLowerCase();
        if (isCreate) {
          if (linkedH5Domain) formData.append('linkedH5Domain', linkedH5Domain);
        } else {
          formData.append('linkedH5Domain', linkedH5Domain);
        }
      }
      const systemName = (this.brandForm.systemName || '').trim();
      if (isCreate) {
        if (systemName) formData.append('systemName', systemName);
      } else {
        formData.append('systemName', systemName);
      }
      formData.append('enabled', String(this.brandForm.enabled));
      const copyright = (this.brandForm.copyright || '').trim();
      const remark = (this.brandForm.remark || '').trim();
      if (isCreate) {
        if (copyright) formData.append('copyright', copyright);
        if (remark) formData.append('remark', remark);
      } else {
        formData.append('copyright', copyright);
        formData.append('remark', remark);
      }
      // 新建 logo 必传；编辑 logo/favicon 可选，有选文件才带上
      if (isCreate) {
        formData.append('logo', this.pendingLogoFile);
      } else if (this.pendingLogoFile) {
        formData.append('logo', this.pendingLogoFile);
      }
      if (this.pendingFaviconFile) {
        formData.append('favicon', this.pendingFaviconFile);
      }
      return formData;
    },
    submitBrandForm() {
      this.$refs.brandFormRef.validate((valid) => {
        if (!valid) return;
        const isEdit = !!this.brandForm.id;
        if (!isEdit && !this.pendingLogoFile) {
          this.$message.warning('请选择 Logo 文件');
          return;
        }
        this.brandSubmitLoading = true;
        const req = isEdit
          ? updateOemBrand(this.brandForm.id, this.buildBrandFormData(false))
          : createOemBrand(this.buildBrandFormData(true));
        req
          .then((res) => {
            if (this.isApiOk(res)) {
              this.$message.success(isEdit ? '修改成功' : '新增成功');
              this.brandDialogVisible = false;
              this.fetchList();
            } else {
              this.$message.error((res && res.msg) || (isEdit ? '修改失败' : '新增失败'));
            }
          })
          .catch(() => {})
          .finally(() => {
            this.brandSubmitLoading = false;
          });
      });
    },
    onPickLogo(option) {
      // 新建/编辑：本地暂存，随 multipart 一起提交
      this.clearPendingLogo();
      this.pendingLogoFile = option.file;
      this.pendingLogoPreview = URL.createObjectURL(option.file);
      this.brandForm.logoFile = option.file.name || 'selected';
      this.$nextTick(() => {
        this.$refs.brandFormRef && this.$refs.brandFormRef.clearValidate('logoFile');
      });
      option.onSuccess && option.onSuccess({});
    },
    onPickFavicon(option) {
      this.clearPendingFavicon();
      this.pendingFaviconFile = option.file;
      this.pendingFaviconPreview = URL.createObjectURL(option.file);
      option.onSuccess && option.onSuccess({});
    },
    openCertDialog(row) {
      this.currentRow = Object.assign({}, row);
      this.pemFile = null;
      this.keyFile = null;
      this.certDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.pemUpload && this.$refs.pemUpload.clearFiles();
        this.$refs.keyUpload && this.$refs.keyUpload.clearFiles();
      });
    },
    resetCertForm() {
      this.pemFile = null;
      this.keyFile = null;
      this.currentRow = {};
    },
    onPemChange(file) {
      this.pemFile = file.raw || file;
    },
    onPemRemove() {
      this.pemFile = null;
    },
    onKeyChange(file) {
      this.keyFile = file.raw || file;
    },
    onKeyRemove() {
      this.keyFile = null;
    },
    submitCert() {
      if (!this.currentRow.id) return;
      if (!this.pemFile || !this.keyFile) {
        this.$message.warning('请同时选择证书 pem 和私钥 key');
        return;
      }
      const formData = new FormData();
      formData.append('pem', this.pemFile);
      formData.append('key', this.keyFile);
      this.certSubmitLoading = true;
      uploadOemCert(this.currentRow.id, formData)
        .then((res) => {
          if (this.isApiOk(res)) {
            const expire =
              res.data && (res.data.certExpireAt || res.data.cert_expire_at);
            this.$message.success(
              expire ? `证书上传成功，到期：${expire}` : '证书上传成功，请再点「发布」'
            );
            this.certDialogVisible = false;
            this.fetchList();
          } else {
            this.$message.error((res && res.msg) || '证书上传失败');
          }
        })
        .catch(() => {})
        .finally(() => {
          this.certSubmitLoading = false;
        });
    },
    handlePublish(row) {
      if (Number(row.certStatus) !== 1) {
        this.$message.warning('请先上传有效证书');
        return;
      }
      this.$confirm(
        `确认发布域名「${row.domain}」？将生成 Nginx 配置并尝试重载。`,
        '发布确认',
        { type: 'warning' }
      )
        .then(() => {
          this.publishLoadingId = row.id;
          return publishOem(row.id);
        })
        .then((res) => {
          if (this.isApiOk(res)) {
            const msg =
              (res.data && (res.data.lastPublishMsg || res.data.message)) ||
              res.msg ||
              '发布成功';
            this.$message.success(msg);
            this.fetchList();
          } else {
            this.$message.error(
              (res && (res.msg || (res.data && res.data.lastPublishMsg))) || '发布失败'
            );
            this.fetchList();
          }
        })
        .catch((err) => {
          if (err !== 'cancel') this.fetchList();
        })
        .finally(() => {
          this.publishLoadingId = null;
        });
    },
    onToggleEnabled(row, enabled) {
      const action = enabled ? enableOem : disableOem;
      const tip = enabled ? '启用' : '停用';
      this.$confirm(`确定${tip}域名「${row.domain}」吗？`, '提示', { type: 'warning' })
        .then(() => {
          this.switchLoadingId = row.id;
          return action(row.id);
        })
        .then((res) => {
          if (this.isApiOk(res)) {
            this.$message.success(`${tip}成功`);
            this.fetchList();
          } else {
            this.$message.error((res && res.msg) || `${tip}失败`);
            this.fetchList();
          }
        })
        .catch((err) => {
          if (err !== 'cancel') this.fetchList();
          else this.fetchList();
        })
        .finally(() => {
          this.switchLoadingId = null;
        });
    },
    handleReloadNginx() {
      this.$confirm('确认仅触发 Nginx reload？不会重新生成 conf。', '提示', {
        type: 'warning'
      })
        .then(() => {
          this.reloadLoading = true;
          return reloadOemNginx();
        })
        .then((res) => {
          if (this.isApiOk(res)) {
            const tip =
              (res.data && (res.data.message || res.data.msg || res.data.lastPublishMsg)) ||
              res.msg ||
              'reload 成功';
            this.$message.success(tip);
          } else {
            this.$message.error(
              (res && ((res.data && res.data.message) || res.msg)) || 'reload 失败'
            );
          }
        })
        .catch((err) => {
          if (err !== 'cancel') {
            /* interceptor 已提示 */
          }
        })
        .finally(() => {
          this.reloadLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.page-breadcrumb {
  margin-bottom: 8px;
}
.search-section {
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}
.search-form .el-form-item {
  margin-bottom: 10px;
  margin-right: 20px;
}
.search-form .search-input {
  width: 220px;
}
.toolbar {
  margin: 0 0 16px;
}
.toolbar .el-button + .el-button {
  margin-left: 10px;
}
.table-card {
  border-radius: 8px;
  overflow: hidden;
}
.table-card >>> .el-card__body {
  padding: 20px;
}
.pagination-wrap {
  margin-top: 16px;
}
.muted {
  color: #909399;
  font-size: 12px;
}
.expire-warn {
  color: #f56c6c;
  font-weight: 500;
}
.upload-row {
  display: flex;
  align-items: center;
  margin-top: 8px;
}
.form-tip {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
}
.media-thumb-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
}
.media-thumb {
  object-fit: contain;
  background: #f5f7fa;
  border-radius: 2px;
}
.media-thumb--logo {
  width: 48px;
  height: 28px;
}
.media-thumb--favicon {
  width: 28px;
  height: 28px;
}
.media-error {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/oms/oemBrandManage.vue